export default __webpack_public_path__ + "static/media/election2015municipal.b293def7.txt";